import { useEffect, useState } from 'react';
import api from '../api';

const useHttpGetDevice = deviceId => {
    const [data, setData] = useState([]);
    const [isReady, setIsReady] = useState(false);

    const fetchDevice = async () => {
        try {
            const deviceData = await api.get_device_info(deviceId);
            setData(deviceData.data);
        } catch (error) {
            console.error('Error fetching device data:', error);
        } finally {
            setIsReady(true);
        }
    };

    useEffect(() => {
        fetchDevice();
    }, []);

    return { data, isReady };
};

export default useHttpGetDevice;
